import { call } from 'redux-saga/effects';

import * as D from '../../deps';
import { getCsWn, getCsXi, pingComscore } from '../../utils';

export function* onLocationChange(action) {
  const url = encodeURI(D.Utils.Route.getOrigin() + action.payload.pathname);
  const listenerId = yield call(getCsXi);
  const ageAndGender = yield call(getCsWn);
  yield call(pingComscore, {
    c4: url,
    cs_xi: listenerId,
    cs_wn: ageAndGender,
  });
}

export function* onSkipTrack(action) {
  const url = encodeURI(`${D.Utils.Route.getOrigin()}/song/skip/${action.data.trackToken}`);
  yield call(pingComscore, {
    c4: url,
  });
}

export function* onThumbDown(action) {
  const url = encodeURI(`${D.Utils.Route.getOrigin()}/song/thumbs-down/${action.data.trackToken}`);
  yield call(pingComscore, {
    c4: url,
  });
}

// TODO: leaving commented out for now until VIDEO_UPDATE action is available
// function* watchAdVideoPlayback() {
//   while (LOOP) {
//     // const action = yield take(D.Constants.Playback.ActionTypes.TRACK_THUMBDOWN);
//     yield call(pingComscore, {
//       'c1': 1,
//       'c5': '09'
//     });
//   }
// }
